/**
 * RPC 错误通道契约：AppError 的线上形态。
 *
 * 业务错误在实现侧仍是 AppError（packages/errors），经 boundary codec 进出
 * RPC 协议；客户端收到后重建为等价对象（code/statusCode/message 齐全）。
 */
import { Schema } from "effect";

export class RpcAppError extends Schema.TaggedErrorClass<RpcAppError>()("RpcAppError", {
  message: Schema.String,
  code: Schema.String,
  statusCode: Schema.Finite,
}) {}

/** AppError（运行态）→ 契约错误（线上） */
export function toRpcAppError(error: {
  readonly message: string;
  readonly code?: string;
  readonly statusCode?: number;
}): RpcAppError {
  return new RpcAppError({
    message: error.message,
    code: error.code ?? "INTERNAL_SERVER_ERROR",
    statusCode: error.statusCode ?? 500,
  });
}

/**
 * 类型级解包：withParse 运行时返回的就是完整 schema 对象（Object.assign 挂
 * parse/safeParse），但类型是轻量 ConstraintCodec。契约层需要 Schema.Top 视图。
 */
export function asContractSchema<A, I>(schema: {
  readonly Type: A;
  readonly Encoded: I;
}): Schema.Codec<A, I> & { readonly "~type.make.in": A } {
  return schema as unknown as Schema.Codec<A, I> & { readonly "~type.make.in": A };
}
